"use client";

import * as React from "react";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/app/components/ui/tabs";
import { cn } from "@/lib/utils";
import {
  backendTabsListClass,
  backendTabsTriggerClass,
} from "./backend-ui-styles";

function BackendTabs({
  className,
  ...props
}: React.ComponentProps<typeof Tabs>) {
  return <Tabs className={cn("flex flex-col gap-2", className)} {...props} />;
}

function BackendTabsList({
  className,
  ...props
}: React.ComponentProps<typeof TabsList>) {
  return (
    <TabsList className={cn(backendTabsListClass, className)} {...props} />
  );
}

function BackendTabsTrigger({
  className,
  ...props
}: React.ComponentProps<typeof TabsTrigger>) {
  return (
    <TabsTrigger
      className={cn(backendTabsTriggerClass, className)}
      {...props}
    />
  );
}

function BackendTabsContent({
  className,
  ...props
}: React.ComponentProps<typeof TabsContent>) {
  return <TabsContent className={cn("outline-none", className)} {...props} />;
}

export { BackendTabs, BackendTabsContent, BackendTabsList, BackendTabsTrigger };
